<template>
  <div class="contract_stock-bd tb" v-if="funcView.stock_cost_scheme_list">
    <div class="search-hd">
      <el-form :inline="true" @submit.native.prevent>
        <el-form-item>
          <el-button type="primary" icon="el-icon-plus" @click="addStock" v-if="funcView.stock_cost_scheme_add">{{funcView.stock_cost_scheme_add}}</el-button>
        </el-form-item>
        <el-form-item style="float: right; margin-right: 0">
          <custom-column ref="column"></custom-column>
        </el-form-item>
        <!-- 搜索栏 -->
        <el-form-item style="float: right">
          <search-input v-model="formSearch.search" :placeholder="$t('crm_contract_stock.fang_an_bian_ma')" @fetch="onPageChange({ page: 1 })"></search-input>
        </el-form-item>
        <el-form-item style="float: right">
          <custom-select
            :filterable="true"
            v-model="formSearch.productCode"
            url="productCodeSelectList"
            :props="{ label: 'productName', value: 'productCode' }"
            :placeholder="$t('crm_contract_stock.chan_pin_xing_hao')"
            width="160px"
            @change="onPageChange({ page: 1 })"
          ></custom-select>
        </el-form-item>
      </el-form>
    </div>
    <div class="table-bd">
      <custom-table height="100%" :data="tableList" tableCode="stock_cost_scheme_table" @filter="filterChange" @sort="sortChange"  @column="setColumn">
        <template slot="action" slot-scope="scope">
          <el-button type="text" size="mini" @click="editStock(scope.row)" v-if="funcView.stock_cost_scheme_edit">{{funcView.stock_cost_scheme_edit}}</el-button>
          <el-button type="text" size="mini" @click="deleteStock(scope.row)" v-if="funcView.stock_cost_scheme_delete">{{funcView.stock_cost_scheme_delete}}</el-button>
          <el-button type="text" size="mini" @click="defaultStock(scope.row)" v-if="funcView.stock_cost_scheme_set_default">{{funcView.stock_cost_scheme_set_default}}</el-button>
        </template>
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
    </div>
    <contract-stock-dialog v-if="dialogVisible" :data="dialogData" :model="dialogModel" @close="dialogVisible = false" @success="getTableList()"></contract-stock-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import contractStockDialog from './children/contract_stock_dialog.vue';

export default {
  components: { contractStockDialog },
  name: 'contract_contractstock',
  data() {
    return {
      formSearch: {
        schemeType: '',
        productCode: '',
        search: '',
        orderBy: '',
        orderType: '',
        pageSize: 50,
        pageNum: 1
      },

      tableList: [],
      totalRows: null,

      dialogVisible: false,
      dialogModel: {},
      dialogData: {}
    };
  },
  mounted: function () {
    this.getTableList();
    this.getFuncView();

  },
  methods: {
    // 获取表格数据列表
    getTableList: function () {
      this.$getJSON(apis.stockCostSchemePage, this.formSearch).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    // 新增
    addStock: function () {
      this.dialogModel.type = 'add';
      this.dialogModel.title = this.$t('crm_contract_stock.xzkcfa');
      this.dialogVisible = true;
    },
    // 编辑
    editStock: function (data) {
      this.dialogModel.type = 'edit';
      this.dialogModel.title = this.$t('crm_contract_stock.bjkcfa');
      this.dialogData.item = data;
      this.dialogVisible = true;
    },
    // 设置默认
    defaultStock: function (data) {
      this.$showConfirm(this.$t('crm_contract_stock.qrmrofa', [data.ruleCode])).then(() => {
        this.$postJSON(`${apis.stockCostSchemeDefault}/${data.stockRuleId}`).then(() => {
          this.$message({
            message: this.$t('crm_contract_stock.szmrkcffacg'),
            type: 'success'
          });
          this.getTableList();
        });
      })
        .catch(() => {});
    },
    // 删除
    deleteStock: function (data) {
      this.$showConfirm(this.$t('crm_contract_stock.nqdyscdqkcfam')).then(() => {
        this.$postJSON(`${apis.stockCostSchemeDelete}/${data.stockRuleId}`).then(() => {
          this.$message({
            message: this.$t('crm_contract_stock.sckcffacg'),
            type: 'success'
          });
          this.getTableList();
        });
      })
        .catch(() => {});
    }
  }
};
</script>

<style lang="scss">
@import 'style/colors.scss';
</style>
